import { characterSelector, serverInfoSelector, useHudStore } from "@/domains/hud/store";
import HudServerInfo from "@/domains/hud/components/HudServerInfo";

export default function HudServerInfoContainer() {
  const character = useHudStore(characterSelector);
  const serverInfo = useHudStore(serverInfoSelector);

  if (!character?.dynamicId && !character?.staticId && !serverInfo) return null;

  return (
    <HudServerInfo dynamicId={character.dynamicId} staticId={character.staticId} {...serverInfo} />
  );
}
